import { useMobileFiltersContext, ON_BOARDING_STATES } from './OnboardingContext'
import { OnBoardingBrands } from './OnboardingBrands'
import { OnBoardingConfirmation } from './OnboardingConfirmation'
import { OnBoardingSports } from './OnboardingSports'
import { OnBoardingAvatar } from './OnboardingAvatar'
import { OnBoardingAbout } from './OnboardingAbout'
import { OnBoardingInit } from './OnboardingInit'

export function OnBoardingSteps({ handleView }) {
  const context = useMobileFiltersContext()

  switch (context.config.currentState) {
    case ON_BOARDING_STATES.INIT: {
      return <OnBoardingInit handleView={handleView} />
    }
    case ON_BOARDING_STATES.ABOUT: {
      return <OnBoardingAbout />
    }
    case ON_BOARDING_STATES.AVATAR: {
      return <OnBoardingAvatar />
    }
    case ON_BOARDING_STATES.SPORTS: {
      return <OnBoardingSports />
    }
    case ON_BOARDING_STATES.BRANDS: {
      return <OnBoardingBrands />
    }
    case ON_BOARDING_STATES.CONFIRMATION: {
      return <OnBoardingConfirmation />
    }
    default: {
      return <h1 class={'h1'}>Error</h1>
    }
  }
}
